import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { CommunitiesScreen } from './CommunitiesScreen';

/** The route `/app/outreach/communities?song=` (design outreach r1). */
const CommunitiesViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const [searchParams] = useSearchParams();
  if (accountId === null) {
    return <LoadingView />;
  }
  return <CommunitiesScreen accountId={accountId} initialSong={searchParams.get('song')} />;
};

export const CommunitiesView = TypedMemo(CommunitiesViewComponent);
